module.exports = __webpack_public_path__ + "img/worldpay_old.ab48b3f3.svg";